import { CrmShell } from "@/components/crm/crm-shell";
import { CrmGrid } from "@/components/crm/crm-grid";

/** Clientes (CRM contacts): Dynamics-style views over the company's contacts. */
export default function Contacts() {
  return <CrmShell currentPage="/contacts">{(ctx) => <CrmGrid entity="contact" ctx={ctx} />}</CrmShell>;
}
